import React, { useCallback } from 'react';
import { int32 } from 'appConstants';
import FormInput from 'components/Input/FormInput';

interface IDelayTimeField {
	changeDelayTime: (value: string) => void;
}

const DelayTimeField: React.FC<IDelayTimeField> = ({ changeDelayTime }) => {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			let onlyDigits = e.target.value.replace(/\D/g, '');
			Number(onlyDigits) > int32 && (onlyDigits = String(int32));
			changeDelayTime(onlyDigits);
			return onlyDigits;
		},
		[changeDelayTime],
	);

	return (
		<FormInput testId="DelayTimeField" name="delayTime" label="delayTimeLabel" getValueFromEvent={handleChange} />
	);
};

export default React.memo(DelayTimeField);
